<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeIntervention.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <a @click="checkPermissions(constantes.INTERVENTION.maj)
          ? $router.push({ name: 'm.logistique.demande_intervention-add'}) : showPopUp()"
                 class="button is-addOrEdit">
                {{ $t('listeIntervention.actions.newIntervention')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllInterventionSelected.length > 0"
          ></selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('listeIntervention.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class='column is-narrow'>
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            class="info-circle-right is-pulled-right is-cursor-pointer"
            @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.INTERVENTION.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="tableWithPerPageSelection">
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        :ref="referenceTable"
        @loaded="finLoading"
        @loading="debutLoading"
        v-if="startArrayRendering && mountedLoadingEnd">
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)"/>
        </template>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox v-model="props.row.selected"/>
        </div>
        <div slot="etat" slot-scope="props" class="columns">
          <b-dropdown v-model="props.row.etat" aria-role="list"
                      @change="switchEtatDemande(props.row, $event)"
                      class="disablejustifyCenter column is-12
                    setWidth100PercentOfSpan pd-3px
                    dropdown-multiple-background-hover-disabled">
            <template #trigger>
              <qd-button class="border-radius-4px" expanded>
                <slot>
                  <div class="columns is-vcentered">
                  <span class="column is-1">
                    <b-icon :icon="getEtatInformation(props.row.etat).icon"
                            :type="getEtatInformation(props.row.etat).type"
                            class="mgt-5px"></b-icon>
                  </span>
                    <span class="column is-8 has-text-left">
                    {{ $t(getEtatInformation(props.row.etat).libelle) }}
                  </span>
                    <span class="column is-3 has-text-centered">
                    <b-icon icon="chevron-down"></b-icon>
                  </span>
                  </div>
                </slot>
              </qd-button>
            </template>
            <b-dropdown-item aria-role="listitem"
                             v-for="etatType in getEtatInformationPossible(props.row)"
                             :key="etatType.key" :value="etatType.key">
              <div class="media">
                <b-icon class="media-left" :icon="etatType.icon"
                        :type="etatType.type"></b-icon>
                <div class="media-content">
                  <h3>{{ $t(etatType.libelle) }}</h3>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div slot="code" slot-scope="props">
          <router-link
            :to="{ name: 'c.logistique.demande_intervention', params: { id: props.row.id } }"
            class="lien"
            :class="{'text-access-no-permission':
          !checkPermissions(constantes.INTERVENTION.lecture)}">
            {{ props.row.code }}
          </router-link>
        </div>
        <div slot="dateSouhaite" slot-scope="props">
          {{ getDate(props.row.datePlanification) }}
        </div>
        <div slot="creationTime" slot-scope="props">
          {{ getDate(props.row.creationTime) }}
        </div>
        <div slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
        </div>
        <div slot="annonceur" slot-scope="props">
          <div v-for="annonceur in getAnnonceurs(props.row)" :key="annonceur.id">
            <router-link-blank
              v-if="annonceur"
              :to="{
                name: 'c.bodac.clients/contacts-client',
                params: {id: annonceur.tiersId}
              }"
              :message="annonceur.nomCommercial"
              :class="{'text-access-no-permission':
                !checkPermissions(permClient.lecture)}"
              class="lien">
            </router-link-blank>
          </div>
        </div>
        <div slot="demandeur" slot-scope="props">
            {{ getUser(props.row) }}
        </div>
        <div slot="source" slot-scope="props">
          {{ $t(getSourceTraduction(props.row.source)) }}
        </div>
        <div slot="actionLogistique" slot-scope="props">
          <b-tooltip :label="props.row.actionLogistique"
                     type="is-primary" multilined
                     position="is-bottom">
            <p class="ellipsis"> {{ props.row.actionLogistique }}</p>
          </b-tooltip>
        </div>
        <div slot="demandeLie" slot-scope="props">
          <a class="lien" v-if="props.row.demandesLogistiqueEnfant.length > 0"
             @click="setDemandeEnfantAndOpenPopUp(props.row.demandesLogistiqueEnfant)">
            {{ $t('listeIntervention.actions.voirDemandeEnfant',
            { nombre: props.row.demandesLogistiqueEnfant.length }) }}
          </a>
          <p v-else> {{ $t('listeIntervention.tab.aucun') }} </p>
        </div>
        <div slot="type" slot-scope="props">
          {{ $t(getTypeIntervention(props.row.type)) }}
        </div>
        <div slot="edit" slot-scope="props">
          <router-link
            :to="{ name: 'm.logistique.demande_intervention-edition',
            params: { id: props.row.id} }">
            <b-icon icon="pencil-box-outline" type="is-success"
                    :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.INTERVENTION.maj) }"></b-icon>
          </router-link>
        </div>
        <div slot="typeOt" slot-scope="props">
          {{ getLibelleTypeOT(props.row.typeOtId) }}
        </div>
        <div slot="otLie" slot-scope="props">
          <router-link-blank :to="{ name: 'c.logistique.ordre_travail-tech',
        params: { id: props.row.otTechnique.id } }"
                             v-if="props.row.otTechnique"
                             :message="props.row.otTechnique.code"
                             typeIcon="is-primary" sizeIcon="is-small">
          </router-link-blank>
        </div>
        <div slot="patrimoineCode" slot-scope="{ row }">
          <router-link-blank
                v-bind="getPatrimoineRouting(row)"
                v-if="getPatrimoineRouting(row)"
                typeIcon="is-primary" sizeIcon="is-small">
          </router-link-blank>
        </div>
      </v-server-table>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-intervention
          ref="filtreIntervention"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"
          :value="critereRecherche"/>
      </div>
    </transition>
    <b-modal v-model="openPopUpFusion" has-modal-card class="modal">
      <intervention-fusion :demandes-intervention="getAllInterventionSelected"
                           @recherche="recherche"/>
    </b-modal>
    <b-modal v-model="openPopUpVisu" has-modal-card class="modal">
      <visualisation-demande-lie :demandesInterventionEnfant="demandesEnfant"/>
    </b-modal>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention v-if="popUpPrevention"
                         :messagesPopup="messagesErreurPopUp"
                         :isErrorPopup.sync="errorPopUp"
                         :mess-header="infoPopUpPrevention.title"
                         :mess-description="infoPopUpPrevention.sousTitle"
                         :previousButton="$t('general.button.cancel')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @previousButton="resetInfo"
                         @close="resetInfo"
                         @yes="updateEtatDemande(true)"
                         @no="updateEtatDemande(false)">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import selecteurAction from '@/components/general/selecteurAction';
import inProgress from '@/services/general/inProgress';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import tableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  ETAT_DEMANDE_INTERVENTION,
  SOURCE_INTERVENTION, TYPE_INTERVENTION,
  ACTION_FUSION, ETAT_VALIDE, ETAT_TRAITE,
  ETAT_NOUVEAU, ETAT_REFUSE, INTERVENTION_TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import formatDate from '@/services/general/formatDate';
import formatIsoDate from '@/services/general/formatIsoDate';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { INTERVENTION } from '@/configuration/logistique/permissionsLogistiqueConf';
import filtreListeIntervention from '@/components/logistique/intervention/liste/filtreListeIntervention';
import { SET_CRITERES } from '@/store/modules/logistique/intervention-mutation-type';
import { updateEtatAsync } from '@/api/logistique/demandeLogistique';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import subscribeMutation from '@/services/store/subscribeMutation';
import interventionFusion from '@/components/logistique/intervention/liste/p_interventionFusion';
import visualisationDemandeLie from '@/components/logistique/intervention/liste/p_visualisationDemandeLie';
import popUpPrevention from '@/components/general/popUpPrevention';
import { ETAT_REALISE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import validation from '@/services/logistique/intervention/validationIntervention';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_INTERVENTION } from '@/configuration/general/referenceTableConf';
import { TIERS } from '@/configuration/permissionsBodacConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

const Societe = createNamespacedHelpers('societe');
const Intervention = createNamespacedHelpers('intervention');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'l_intervention',
  data() {
    return {
      showFiltre: false,
      etatIntervention: ETAT_DEMANDE_INTERVENTION,
      sourceIntervention: SOURCE_INTERVENTION,
      typeIntervention: TYPE_INTERVENTION,
      unsubscribeValue: null,
      openPopUpFusion: false,
      openPopUpVisu: false,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      demandesEnfant: [],
      actionUpdateEtat: false,
      popUpPrevention: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      infoPopUpPrevention: {
        title: '',
        sousTitle: '',
      },
      demandeToEdit: {
        key: null,
        ids: [],
        etat: null,
        previousEtat: null,
      },
      constantes: {
        INTERVENTION,
      },
      actions: [
        { action: ACTION_FUSION, translation: 'listeIntervention.actions.fusion' },
      ],
      referenceTable: REFERENCE_TABLE_LISTE_INTERVENTION,
      resultPerPage: RESULTS_PER_PAGE,
      permClient: TIERS,
    };
  },
  components: {
    breadcrumb,
    selecteurAction,
    tableItemsInView,
    filtreListeIntervention,
    interventionFusion,
    visualisationDemandeLie,
    popUpPrevention,
    routerLinkBlank,
    parametrageTable,
    exportExcelButton,
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Intervention.mapActions({
      loadIntervention: 'loadIntervention',
    }),
    ...Intervention.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    setDemandeEnfantAndOpenPopUp(demandes) {
      this.demandesEnfant = demandes;
      this.openPopUpVisu = true;
    },
    getPatrimoineRouting(row) {
      if (!row.emplacementId) return null;
      const routingProps = {
        message: row.patrimoineCode,
        to: {
          name: 'c.gabed.emplacement-detailEmplacement',
          params: { id: row.emplacementId },
        },
      };
      if (row.dispositifId) {
        routingProps.to = {
          name: 'c.gabed.emplacement-detailDispositif',
          params: { ...routingProps.to.params, idDispositif: row.dispositifId },
        };
      }
      if (row.materielId) {
        routingProps.to = {
          name: 'c.gabed.emplacement-detailMateriel',
          params: { ...routingProps.to.params, idMateriel: row.materielId },
        };
      }
      if (row.faceId) {
        routingProps.to = {
          name: 'c.gabed.emplacement-face',
          params: { ...routingProps.to.params, idFace: row.faceId },
        };
      }
      return routingProps;
    },
    async switchEtatDemande(demande, etat) {
      this.demandeToEdit = {
        key: etat,
        ids: [demande.id],
        etat: etat,
        previousEtat: demande.etat,
      };
      if (etat === ETAT_VALIDE && demande.otTechnique === null
        && demande.type === INTERVENTION_TYPE_INTERVENTION) {
        this.infoPopUpPrevention = {
          title: this.$i18n.t('listeIntervention.etat.valide.title'),
          sousTitle: this.$i18n.t('listeIntervention.etat.valide.sousTitle'),
        };
        this.popUpPrevention = true;
        return;
      }
      if (etat === ETAT_TRAITE && demande.otTechnique
        && demande.otTechnique.etat !== ETAT_REALISE) {
        this.infoPopUpPrevention = {
          title: this.$i18n.t('listeIntervention.etat.traite.title'),
          sousTitle: this.$i18n.t('listeIntervention.etat.traite.sousTitle'),
        };
        this.popUpPrevention = true;
        return;
      }
      await this.updateEtatDemande(false);
    },
    async resetInfo() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        this.errorPopUp = false;
        this.demandeToEdit = {
          key: null,
          ids: [],
          etat: null,
        };
        this.infoPopUpPrevention = {
          title: null,
          sousTitle: null,
        };
        this.popUpPrevention = false;
        await this.recherche();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async updateEtatDemande(action) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        this.errorPopUp = false;
        const data = {
          demandeIds: this.demandeToEdit.ids,
          etat: this.demandeToEdit.etat,
          actionUpdateEtat: action,
        };
        await updateEtatAsync(data);
        messageSucces(this.$t('listeIntervention.success.demandeEtatEdit'));
        await this.resetInfo();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, this.interventions);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    manageActions(action) {
      switch (action) {
        case ACTION_FUSION:
          this.openPopUpFusion = true;
          break;
        default:
          this.inProgress();
          break;
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    makeRechercheFilter(critereUpdate) {
      this.setCritereRecherche(critereUpdate);
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreIntervention.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreIntervention.initializeFiltre();
      this.$refs.filtreIntervention.viderCritere();
      this.$refs.filtreIntervention.appliquerCritere();
      this.showFiltre = false;
    },
    selectAll() {
      const select = !this.allInterventionSelected;
      this.interventions.forEach(item => {
        item.selected = select;
      });
    },
    getDate(date) {
      return formatDate(date);
    },
    getUser(demande) {
      if (!demande.demandeurId) return '';
      return nomPrenomGetter(demande.demandeur);
    },
    getSourceTraduction(sourceKey) {
      const source = this.sourceIntervention.find((source) => {
        return source.key === sourceKey;
      });
      if (!source) return null;
      return source.libelle;
    },
    getTypeIntervention(typeKey) {
      const type = this.typeIntervention.find((type) => {
        return type.key === typeKey;
      });
      if (!type) return null;
      return type.libelle;
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agence) return agence.libelleAgence;
      return null;
    },
    getEtatInformation(key) {
      return this.etatIntervention.find((etat) => {
        return etat.key === key;
      });
    },
    getEtatInformationPossible(demande) {
      const etats = [];
      if (demande.etat !== ETAT_VALIDE) etats.push(cloneDeep(ETAT_DEMANDE_INTERVENTION[1]));
      if (demande.etat !== ETAT_TRAITE) etats.push(cloneDeep(ETAT_DEMANDE_INTERVENTION[2]));
      if (demande.etat === ETAT_REFUSE || demande.etat === ETAT_NOUVEAU
        || (((demande.etat === ETAT_VALIDE
          || demande.etat === ETAT_REFUSE) && !demande.otTechnique))) {
        etats.push(cloneDeep(ETAT_DEMANDE_INTERVENTION[3]));
      }
      return etats;
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesIds = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.recherche();
    },
    getLibelleTypeOT(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getAnnonceurs(row) {
      return row.ligneCommande?.allAnnonceurs;
    },
  },
  computed: {
    ...Intervention.mapGetters({
      interventions: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        {
          title: this.$t('listeIntervention.breadcrumb.home'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        {
          title: this.$t('listeIntervention.breadcrumb.listeIntervention'),
          route: '',
          isActive: true,
        },
      ];
    },
    allInterventionSelected() {
      return this.getAllInterventionSelected.length === this.interventions.length
        && this.interventions.length > 0;
    },
    iconSelectTotal() {
      if (this.allInterventionSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      return ['selected', 'etat', 'code', 'creationTime', 'actionLogistique', 'agence', 'adresse.adresse1', 'adresse.codePostal', 'adresse.ville', 'patrimoineCode', 'dateSouhaite', 'type', 'typeOt', 'annonceur', 'demandeur', 'source', 'demandeLie', 'otLie', 'edit'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          etat: this.$t('listeIntervention.tab.etat'),
          code: this.$t('listeIntervention.tab.numeroDemande'),
          creationTime: this.$t('listeIntervention.tab.date'),
          actionLogistique: this.$t('listeIntervention.tab.sujet'),
          agence: this.$t('listeIntervention.tab.agence'),
          patrimoineCode: this.$t('listeIntervention.tab.patrimoine'),
          'adresse.adresse1': this.$t('listeIntervention.tab.patrimoineAdresse'),
          'adresse.codePostal': this.$t('listeIntervention.tab.codePostal'),
          'adresse.ville': this.$t('listeIntervention.tab.ville'),
          dateSouhaite: this.$t('listeIntervention.tab.dateSouhaite'),
          annonceur: this.$t('listeIntervention.tab.annonceur'),
          demandeur: this.$t('listeIntervention.tab.demandeur'),
          source: this.$t('listeIntervention.tab.source'),
          type: this.$t('listeIntervention.tab.type'),
          typeOt: this.$t('listeIntervention.tab.typeOt'),
          demandeLie: this.$t('listeIntervention.tab.demandeLie'),
          otLie: this.$t('listeIntervention.tab.otLie'),
          edit: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (this.critereRecherche.agencesIds.length === 0) {
            this.critereRecherche.agencesIds = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.dateCreationTime.dateDebut && data.query.dateCreationTime.dateFin) {
            data.query.dateCreationTime.dateDebut = formatIsoDate(
              data.query.dateCreationTime.dateDebut,
            );
            data.query.dateCreationTime.dateFin = formatIsoDate(
              data.query.dateCreationTime.dateFin,
            );
          }
          if (data.query.datePlanification.dateDebut && data.query.datePlanification.dateFin) {
            data.query.datePlanification.dateDebut = formatIsoDate(
              data.query.datePlanification.dateDebut,
            );
            data.query.datePlanification.dateFin = formatIsoDate(
              data.query.datePlanification.dateFin,
            );
          }
          return this.loadIntervention(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.interventions,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          actionLogistique: 'planningTailleColonneLibelleNumerique',
          edit: 'colonneSelected',
          etat: 'width-170px',
        },
        sortable: ['etat', 'code', 'creationTime', 'actionLogistique', 'adresse.adresse1', 'adresse.codePostal', 'adresse.ville', 'dateSouhaite', 'type', 'source'],
      };
    },
    nombreCritere() {
      const banCritere = ['auto', 'dateCreationTime', 'datePlanification', 'sansParent'];
      if (this.agencesSelectionnees.length === 1) banCritere.push('agencesIds');
      let nbFiltre = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dateCreationTime.dateDebut
        && this.critereRecherche.dateCreationTime.dateFin) {
        nbFiltre += 1;
      }
      if (this.critereRecherche.datePlanification.dateDebut
        && this.critereRecherche.datePlanification.dateFin) {
        nbFiltre += 1;
      }
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    getAllInterventionSelected() {
      return this.interventions.filter((el) => {
        return el.selected;
      });
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.setInformationPage(this.$t('pageLogistique.intervention.liste'));
      this.critereRecherche.agencesIds = this.agencesSelectionnees.map((agence) => agence.agenceId);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw error;
    }
  },
};
</script>
